angular.module('jv.Admin.Users')
    .factory('alertModalFAC', function(){
        return function(modalConfig){
            return{
                show: true,
                cancel: modalConfig.Cancel.click,
                buttons:[
                    {
                        label: modalConfig.OK.title,
                        title: modalConfig.OK.title,
                        click: modalConfig.OK.click,
                        'class': 'btn'
                    },
                    {
                        label: modalConfig.Cancel.title,
                        title: modalConfig.Cancel.title,
                        click: modalConfig.Cancel.click,
                        'class': 'btn cancel'
                    }
                ],
                title: modalConfig.title,
                body: modalConfig.body
            };
        };
    })
    
    .filter('valueTypeFilter', function() {
        return function(item) {
            var result = item;
            if (angular.isNumber(item)) {
                result = (item === 1) ? 'Import' : 'Manual';
            } else if (typeof item === 'string') {
                result = (item === 'true') ? 'Enable' : 'Disable';
            }
            return result;
        };
    })

    .factory('sortCollectionByProperty', [function(){
        return function(hashmap, property){
            var arr  = [];
            for(var key in hashmap){
                var obj = hashmap[key];
                obj.fieldValue = key;
                arr.push(obj);
            }
            return arr.sort(function(a,b) {
                if (a[property] < b[property]){
                    return -1;
                }
                if (a[property] > b[property]){
                    return 1;
                }
                return 0;
            });
        };
    }])

    .factory('fieldLookUps',[function () {
        return function(formFields) {
            return formFields.reduce(function(total, item){
                if(item.fieldValue || item.fieldName){
                    total.push({'name':item.fieldValue,'code':item.fieldCode});
                }
                return total;
            },[]);
        };
    }])

    .controller('jvAdminUsersEmplyeeSettingsController',
        ['$scope', 'adminSettingsSVC', 'breadcrumbsResolve', '$timeout', 'alertModalFAC','sortCollectionByProperty','fieldLookUps',
            function($scope, adminSettingsSVC, breadcrumbsResolve, $timeout, alertModalFAC, sortCollectionByProperty,fieldLookUps) {
                $scope.breadcrumbsConfig = breadcrumbsResolve;
                $scope.employeeSelect = adminSettingsSVC.employeeSelect;
                $scope.flags = $scope.flags || {};
                $scope.flags.loading = true;
                $scope.fileName = null;
                $scope.startDate = null;
                $scope.fileType = null;
                $scope.waitingForResponse = true;
                $scope.sectionArray = [];
                $scope.onProfile = true;
                $scope.manualFileUploaded = false;
                $scope.showEmployeeProfileFields = false;
                var getFieldCodeRuleValue = function(text){
                    return text.replace(/ /g,'_').replace(/[^a-zA-Z0-9_]/g,'').toLowerCase();
                };
                $scope.fieldSettings = {
                    getUploadedFileDetails: function() {
                        adminSettingsSVC.getUploadedFileDetails(this.getUploadedFileDetailsSuccess, this.getError);
                    },
                    getUploadedFileDetailsSuccess: function(data) {
                        $scope.showEmployeeProfileFields = true;
                        if(data && data.executions && data.executions.length > 0) {
                            var latestExecution = data.executions[0];
                            if(latestExecution.internalSourceFile) {
                                var filePathArray = latestExecution.internalSourceFile.split('/');
                                if(filePathArray && filePathArray.length > 0) {
                                    $scope.fileName = filePathArray[filePathArray.length - 1];
                                }
                            }
                            if(latestExecution.startTime) {
                                $scope.startDate = latestExecution.startTime;
                            }
                            if(latestExecution.job && latestExecution.job.connector && latestExecution.job.connector.type) {
                                $scope.fileType = latestExecution.job.connector.type;
                            }
                            if(latestExecution.sourceFile) {
                                $scope.sourceFile = latestExecution.sourceFile;
                            }
                            if(latestExecution.sourceFileInBytes) {
                                $scope.sourceFileInBytes = latestExecution.sourceFileInBytes;
                            }
                            
                        }
                        $scope.fieldSettings.getSelect2MappingValues(data);
                    },
                    getError: function() {
                        $scope.flags.loading = false;
                        $scope.waitingForResponse = false;
                    },
                    getSelect2MappingValues: function(data) {
                        if(data && data.executions && data.executions.length > 0) {
                            $scope.manualFileUploaded = true;
                            var latestExecution = data.executions[0];
                            if(latestExecution && latestExecution.job && 
                                    latestExecution.job.connector && latestExecution.job.connector.parameters && latestExecution.job.connector.parameters.fileName) {
                                adminSettingsSVC.getSelect2MappingValues(latestExecution.job.connector.parameters.fileName, latestExecution.job.connector.parameters.delimiter, this.getSelect2MappingValuesSuccess, this.getError);
                            }
                        } else {
                            adminSettingsSVC.getColumnMapping($scope.fieldSettings.getColumnMappingSuccess, $scope.fieldSettings.getError);
                        }
                    },
                    validate: function(section) {
                        section.warning = false;
                        for(var entries in section) {
                            if((section[entries].required || section[entries].selected) && section[entries].toAttribute && section[entries].toAttribute.text.trim() === '') {
                                section.warning = true;
                            }
                        }
                        return section;
                    },
                    cleanCustomField: function(section) {
                        for(var entry in section) {
                            if(section[entry].custom) {
                                   if(section[entry].fieldValue && section[entry].fieldValue.trim() !== '' && section[entry].fieldValue !== entry) {
                                    section[section[entry].fieldValue] = section[entry];
                                    delete section[entry];
                                }
                            }
                        }
                        return section;
                    },
                    downloadEmployeeSyncFile: function(url) {
                        adminSettingsSVC.downloadEmployeeSyncFile(url);
                    },
                    beforeSave: function(section) {
                        for(var entry in section) {
                            /* The fieldId for 'End Date' and 'User ID' field is -22 and -30 respectively. 
                             * We do not want to show these fields in the Employee Details section.
                             * Want to make sure front-end always sends false for onProfile.
                             * This way 'Display in Employee Profile' will always show up as false in 'Manage Employee Fields' section as well.
                             *
                             */
                            if(section[entry].fieldId === -22 || section[entry].fieldId === -30 || section[entry].fieldId === -32 || section[entry].fieldId === -33) {
                                section[entry].onProfile = false;
                            }
                             if(section[entry].toAttribute && section[entry].toAttribute !== '' && section[entry].toAttribute !== null && section[entry].toAttribute !== undefined) {
                                if(angular.isObject(section[entry].toAttribute)){
                                    if(section[entry].toAttribute.length !== 0){
                                         if(section[entry].selected){
                                            section[entry].sync = true;
                                            section[entry].toAttribute = section[entry].toAttribute.id || '';
                                         } else{
                                            section[entry].toAttribute = '';
                                            section[entry].sync = false;
                                        }
                                    }
                                }
                            } else {
                                section[entry].toAttribute = '';
                                section[entry].sync = false;
                            }
                            delete section[entry].selected;
                            delete section[entry].showError;
                            delete section[entry].notes;
                            delete section[entry].iconColor;
                            delete section[entry].fieldValue;
                            delete section[entry].disbaledDisplayOnProfile;
                        }
                        return section;
                    },
                    setEditMode: function(section) {
                        section.edit = true;
                    },
                    deleteField: function(object) {
                        object['delete'] = true;
                    },
                    
                    addField: function(section) {
                        var position = (section.fields && section.fields.length) ? (angular.copy(section.fields).pop().position+1) : 1;
                        section.fields = section.fields || [];
                        section.fields.push({
                            'custom': true,
                            'delete': false,
                            'fieldId': 0,
                            'onProfile': true,
                            'position': position,
                            'required': false,
                            'section': section.sectionName,
                            'selected': false,
                            'sync': false,
                            'toAttribute': ''
                        });
                    },
                    fieldCode:{
                        generate: function(object){
                            if(object.fieldId === 0){
                                object.fieldCode = getFieldCodeRuleValue(object.fieldValue);
                            }
                            return object;
                        },
                        validate: function(object){
                            if(object.fieldId === 0){
                                object.showFieldCodeError = object.fieldCode && $scope.fieldSettings.fieldCodeLookUps[object.fieldCode]===true;
                            }
                            return object;
                        },
                        keyCheck: function(e){
                            if(e.keyCode !== 8 && e.key !== getFieldCodeRuleValue(e.key)){
                                e.preventDefault();
                            }
                        }
                    },
                    fieldName:{
                        validate: function(object){
                            if(object.fieldId === 0){
                                object.showFieldNameError = object.fieldValue && $scope.fieldSettings.fieldNameLookUps[object.fieldValue]===true;
                            }
                            return object;
                        }
                    },
                    cancel: function(index) {
                        var initialData = $scope.sectionArrayInitial[index];
                        initialData.expand = true;
                        angular.extend($scope.sectionArray[index],  initialData);
                    },
                    saveMapping: function(section, index) {
                        var postData = angular.copy($scope.response);
                        var formIsValid = true;
                        $scope.flags.loading = true;
                        $scope.fieldSettings.currentSection = {
                            key: section.key,
                            index: index
                        };
                        angular.forEach(section.fields, function(updatedField){
                            if(updatedField.fieldId !== 0){
                                angular.forEach(postData[section.key], function(actualField, actualFieldKey){
                                    if(actualFieldKey === updatedField.fieldValue){
                                        angular.extend(actualField, updatedField);
                                    }
                                });
                            } else{
                                $scope.fieldSettings.fieldCode.validate(updatedField);
                                $scope.fieldSettings.fieldName.validate(updatedField);
                                postData[section.key][updatedField.fieldValue] = angular.copy(updatedField);
                                formIsValid = !!(updatedField.fieldValue && updatedField.fieldCode);
                                formIsValid = formIsValid && !updatedField.showFieldCodeError && !updatedField.showFieldNameError;
                                updatedField.showFieldCodeError = !(updatedField.fieldCode) ? true:!formIsValid;
                                updatedField.showFieldNameError = !(updatedField.fieldValue) ? true:!formIsValid && updatedField.showFieldNameError;
                            }
                            if(updatedField.onProfile == false){
                                    postData[section.key][updatedField.fieldValue].onMyAccountProfile = false;
                            }
                        });
                        if(!formIsValid){
                            $scope.flags.loading = false;
                            return;
                        }
                        postData[section.key] = this.cleanCustomField(postData[section.key]);
                        //entire post data needs to be cleaned before sending to backend
                        angular.forEach($scope.sectionArray, function(fieldSection){
                            postData[fieldSection.key] = $scope.fieldSettings.beforeSave(postData[fieldSection.key]);
                        });
                        if(postData && postData.columnMappingId && (postData.columnMappingId).trim() !== '') {
                            adminSettingsSVC.updateMapping(postData, function(){
                                $scope.flags.loading = false;
                                adminSettingsSVC.getColumnMapping($scope.fieldSettings.saveColumnMappingSuccess, $scope.fieldSettings.getError, true);
                            });
                        } else {
                            adminSettingsSVC.submit(postData, function(){
                                $scope.flags.loading = false;
                                adminSettingsSVC.getColumnMapping($scope.fieldSettings.saveColumnMappingSuccess, $scope.fieldSettings.getError, true);
                            });
                        }
                    },
                    saveColumnMappingSuccess: function(response){
                        angular.extend($scope.response, response);
                        var key = $scope.fieldSettings.currentSection.key;
                        var index = $scope.fieldSettings.currentSection.index;
                        if(response[key] && !$.isEmptyObject(response[key])){
                            var data = $scope.fieldSettings.getColumnsMappingProcessing(response[key], key, false, true);
                            $scope.sectionArray[index] = data;
                            $scope.sectionArrayInitial[index] = angular.copy(data);
                        } else{
                            $scope.sectionArray[index].fields = [];
                            $scope.sectionArrayInitial[index].fields = [];
                        }
                    },
                    getSelect2MappingValuesSuccess: function(response) {
                        $scope.standardJobCategoryNames = [];
                        var employeeSampleDataArray = '';
                        if(response && response.EmployeeSampleData) {
                            employeeSampleDataArray = JSON.parse(response.EmployeeSampleData);
                        }
                        if(employeeSampleDataArray && employeeSampleDataArray.length > 0) {
                            for(var i=0; i < employeeSampleDataArray.length ; i++) {
                                var employeeSampleDataObject = employeeSampleDataArray[i];
                                var keysInEmployeeSampleDataObject = Object.keys(employeeSampleDataObject);
                                if(keysInEmployeeSampleDataObject && keysInEmployeeSampleDataObject.length > 0) {
                                    // Getting the first key from the array of keys (always with length 1) for the employeeSampleDataObject
                                    var key = keysInEmployeeSampleDataObject[0];
                                    $scope.standardJobCategoryNames.push({id:key, text: key, value:employeeSampleDataObject[key]});
                                }
                            }
                        }
                        //Get mappings
                        adminSettingsSVC.getColumnMapping($scope.fieldSettings.getColumnMappingSuccess, $scope.fieldSettings.getError);
                    },
                    getPreSelectedValue : function(value){
                        var selectedVal = null;
                        if($scope.standardJobCategoryNames && $scope.standardJobCategoryNames.length > 0) {
                            angular.forEach($scope.standardJobCategoryNames, function(standardJobCategoryNames){
                               if(standardJobCategoryNames.id === value) {
                                   selectedVal = standardJobCategoryNames;
                               }
                            });
                            return selectedVal;
                        }
                    },
                    getColumnsMappingProcessing: function(section, key, edit, expand) {
                        var entry = null;
                        for(entry in section) {
                            section[entry].selected  = section[entry].sync;
                           if(section[entry].toAttribute && section[entry].toAttribute.trim() !== '') {
                                section[entry].toAttribute = $scope.fieldSettings.getPreSelectedValue(section[entry].toAttribute);
                            }
                            /* The fieldId for 'End Date' and 'User ID' field is -22 and -30 respectively.
                             * We are not displaying these in the employee details section, so by default 'Display in Employee Profile' would be shown as 'No'
                             * And then the slider is disabled so that user cannot enable 'Display in Employee Profile' for 'End Date' and 'User ID'
                             */
                            if(section[entry].fieldId === -22 || section[entry].fieldId === -30||section[entry].fieldId === -32
                            		||section[entry].fieldId === -33) {
                                section[entry].onProfile = false;
                                section[entry].disbaledDisplayOnProfile = true;
                            }
                            if(section[entry].fieldId === -35) {
                                section[entry].disbaledDisplayOnProfile = true;
                            }
                            if(section[entry].fieldId === -9 || section[entry].fieldId === -35){
                                section[entry].disbaledDisplayOnMyAccountProfile = true;
                            }
                            section[entry].fieldValue = entry;
                        }
                        var formFields = sortCollectionByProperty(section, 'position');
                        if(section[Object.keys(section)[0]].section === i18n.ORGANIZATION_FIELDS){
                            $scope.fieldSettings.fieldCodeLookUps = [];
                            $scope.fieldSettings.fieldNameLookUps = [];
                            fieldLookUps(formFields).forEach(function(item){
                                if(item.name || item.code){
                                    $scope.fieldSettings.fieldNameLookUps[item.name] = true;
                                    $scope.fieldSettings.fieldCodeLookUps[item.code] = true;
                                }
                            });
                        }
                        return {
                            sectionName: section[entry].section,
                            fields: formFields,
                            key: section.key || key,
                            edit: edit || false,
                            expand: expand || false,
                            fieldCode: section.fieldCode || true
                        };
                    },
                    expandCollapse: function(section) {
                        section.expand = !section.expand;
                    },
                    getColumnMappingSuccess: function(response) {
                        var sections = ['personal', 'jobInformation', 'contactInformation', 'regionInformation','organizationInformation'];
                        $scope.response = angular.copy(response);
                        $scope.sectionArray = [];
                        $scope.sectionArrayInitial = [];
                        $scope.fieldSettings.fieldCodeLookUps = [];
                        $scope.fieldSettings.fieldNameLookUps = [];
                        for(var section in sections){
                            var data = $scope.fieldSettings.getColumnsMappingProcessing(response[sections[section]], sections[section]);
                            data.fieldCode = sections[section] === 'organizationInformation';
                            $scope.sectionArray.push(data);
                            $scope.sectionArrayInitial.push(angular.copy(data));
                        }
                        if(response.hasCustomFields){
                            var customInformation = $scope.fieldSettings.getCustomFieldSection(response);
                            $scope.sectionArray.push(customInformation);
                            $scope.sectionArrayInitial.push(angular.copy(customInformation));
                        }
                        $scope.flags.loading = false;
                    },
                    getCustomFieldSection: function(response){
                        if($.isEmptyObject(response.customInformation)){
                            return {
                                key: 'customInformation',
                                sectionName: i18n.ADMIN_CUSTOM_FIELDS,
                                edit: true,
                                expand: false,
                                fieldCode: true
                            };
                        } else{
                            return $scope.fieldSettings.getColumnsMappingProcessing(response.customInformation, 'customInformation');
                        }
                    }
                };
                $scope.fieldSettings.getUploadedFileDetails();
            }
        ]);
